<template>
  <div class="pending">
    <h1 class="normal" id="page-title-for-sr">
      <span class="sr-only">{{ $t('confirmation.pageTitle') }}: </span>
      <span aria-live="assertive" role="status" v-html="$t('confirmation.pending.header')"></span>
    </h1>
    <p v-html="$t('confirmation.pending.description')"></p>
  </div>
</template>
<script>
export default {
  name: 'ConfirmationPending'
}
</script>
